import store from "~/store";
import { loadMessages } from "~/plugins/i18n";

function localeIsValid(locale) {
    let locales = store.getters["lang/locales"];
    return locale && locales.indexOf(locale) > -1;
}

function getRouteWithoutLang(route) {
    let path = route.path;
    let { lang } = route.params;
    if (path.includes(lang)) {
        path = path.replace("/" + lang, "");
    }
    return path;
}

export default async (to, from, next) => {
    const { lang } = to.params;
    const redirectTo = localeIsValid(lang) ? to.fullPath : getRouteWithoutLang(to);
    if(lang){
        await store.dispatch("lang/setLocale", {
            locale: to.params.lang
        });
    }
    if (lang && (to.fullPath !== redirectTo)) {
        next({ path: redirectTo });
        return;
    }
    await loadMessages(store.getters["lang/locale"]);

    next();
    return;
};
